export default function Hero() {
  return (
    <section id="top" className="relative w-full h-[560px] md:h-[720px] lg:h-[820px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20breathtaking%20panoramic%20view%20of%20a%20lush%20green%20alpine%20dairy%20pasture%20at%20golden%20hour%2C%20soft%20warm%20sunlight%20cascading%20over%20rolling%20emerald%20hills%2C%20a%20small%20herd%20of%20healthy%20black%20and%20white%20holstein%20dairy%20cows%20grazing%20peacefully%20in%20the%20distance%2C%20wooden%20fence%20line%2C%20wildflowers%20in%20the%20foreground%2C%20distant%20snow%20capped%20mountains%20under%20a%20warm%20cinematic%20sky%20with%20soft%20clouds%2C%20editorial%20farm%20photography%2C%20cinematic%20wide%20shot%2C%20natural%20film%20grain%2C%20warm%20golden%20amber%20tones%2C%20highly%20detailed%20realistic%20atmosphere&width=1920&height=1080&seq=vef-hero-2026-01&orientation=landscape"
        alt="CCF Global Dairy Farming Platform · Alpine Pasture in Golden Sunlight"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex items-center">
        <div className="w-full px-6 md:px-10 lg:px-14 pt-24">
          <div className="max-w-4xl animate-fade-up">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-background-50/30 bg-background-50/10 backdrop-blur-sm">
              <span className="w-2 h-2 rounded-full bg-primary-400"></span>
              <span className="text-xs md:text-sm font-medium tracking-wide text-background-50">
                58 Global Partner Farms · Serving 50,000+ Members
              </span>
            </div>

            <h1
              className="mt-6 text-background-50 font-heading font-semibold tracking-tight leading-[1.05]"
              style={{ fontFamily: "Fraunces, serif" }}
            >
              <span className="block text-3xl md:text-5xl lg:text-7xl">Farm with the World.</span>
              <span className="block text-3xl md:text-5xl lg:text-7xl">Raise a Dairy Cow That Earns.</span>
            </h1>

            <p className="mt-6 max-w-2xl text-sm md:text-lg text-background-100/90 leading-relaxed">
              CCF partners with premium dairy farms worldwide, using a diversified farming strategy to reduce risk. The majority of profits go back to our online members — you choose, the farms care, and we share the returns together.
            </p>

            <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-stretch sm:items-center gap-3 md:gap-4">
              <a
                href="https://dna-6027.jdwe.live"
                className="px-7 py-4 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-seedling-line mr-2"></i>
                Start My First Dairy Cow
              </a>
              <a
                href="#how"
                className="px-7 py-4 rounded-md bg-background-50/10 border border-background-50/30 text-background-50 text-sm md:text-base font-semibold hover:bg-background-50/20 backdrop-blur-sm transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-play-circle-line mr-2"></i>
                See How It Works
              </a>
            </div>

            <div className="mt-10 md:mt-14 grid grid-cols-3 gap-3 md:gap-6 max-w-2xl">
              {[
                { k: "58", u: "", label: "Global Partner Farms" },
                { k: "50.0K", u: "+", label: "Online Members" },
                { k: "80%", u: "", label: "Profit Return Rate" },
              ].map((s) => (
                <div key={s.label} className="border-l border-background-50/30 pl-4">
                  <div
                    className="flex items-baseline gap-1 text-background-50 font-heading text-xl md:text-3xl lg:text-4xl font-semibold"
                    style={{ fontFamily: "Fraunces, serif" }}
                  >
                    <span>{s.k}</span>
                    <span className="text-lg text-accent-300">{s.u}</span>
                  </div>
                  <div className="mt-1 text-[10px] md:text-sm text-background-100/80 tracking-wide">
                    {s.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 flex-col items-center text-background-50/80 hidden md:flex">
        <span className="text-xs tracking-widest uppercase">Scroll</span>
        <div className="mt-2 w-px h-8 bg-background-50/40 animate-float-y"></div>
      </div>
    </section>
  );
}